<template>
  <div>
    <v-row>
      <!-- 配車管理一覧 -->
      <v-col cols="12">
        <v-row dense>
          <v-col
            cols="12"
            md="4"
          >
            <h2>
              <v-row dense>
                <v-col cols="12">
                  <span style="display: inline-block;vertical-align: top;margin-right: 20px;">
                  <v-icon class="mr-2">
                    mdi-truck-outline
                  </v-icon>
                    配車計画
                  </span>
                  <span style="display: inline-block;vertical-align: top;" class="text-h6 font-weight-regular">
                    {{ targetDate | date_format('MM') }}/
                  </span>
                  <span class="text-h4 font-weight-regular">
                    {{ targetDate | date_format('DD') }}
                  </span>
                  <span class="text-h6 font-weight-regular" style="display: inline-block;width: 48px">
                    {{ targetDate | date_format('ddd') }}
                  </span>
                  <div
                    style="display: inline-block;"
                  >
                    <div style="display: flex;">
                      <v-btn
                        icon
                        class="font-weight-bold"
                        @click="previousButtonClickEvent"
                      >
                        <v-icon large>
                          mdi-chevron-left
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        class="font-weight-bold"
                        @click="nextButtonClickEvent"
                      >
                        <v-icon large>
                          mdi-chevron-right
                        </v-icon>
                      </v-btn>
                      <cs-date-picker
                        :date.sync="targetDate"
                        @dateChangedCallback="targetDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-btn
                            v-model="targetDate"
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            dark
                            elevation="0"
                            fab
                            small
                          >
                            <v-icon dark>
                              mdi-calendar-month-outline
                            </v-icon>
                          </v-btn>
                        </template>
                      </cs-date-picker>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </h2>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <div style="width: 100%">
              <div
                :style="`width: ${$vuetify.breakpoint.mdAndUp ? '45' : '60'}%`"
                style="display: inline-block;"
              >
                <v-select
                  v-model="sortPriority"
                  :items="sortPriorities"
                  dense
                  background-color="white"
                  hide-details="auto"
                  outlined
                  style="font-size: 80%"
                  rounded
                  @change="sortChangeEvent"
                />
              </div>
              <div
                :style="`width: ${$vuetify.breakpoint.mdAndUp ? '25' : '40'}%`"
                style="display: inline-block;text-align: right;"
              >
                <v-menu
                  ref="driverMenu"
                  v-model="showDriverSetting"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-account-outline</v-icon>
                      {{ drivers.length }}名<v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    dense
                    style="max-height: 50vh;overflow-y: auto"
                  >
                    <v-list-item
                      v-for="driver in drivers"
                      :key="driver.id"
                      dense
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            dense
                            v-model="driver.enabled"
                            color="primary"
                          />
                        </v-list-item-action>
                        <v-list-item-avatar size="35">
                          <v-img
                            v-if="driver.image_url"
                            :alt="`${driver.name} avatar`"
                            :src="driver.image_url | load_image_url"
                          />
                          <v-avatar
                            v-else
                            color="primary"
                            size="40"
                          >
                          <span class="primary white--text body-2">
                            {{ driver.name.slice(0, 2) }}
                          </span>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            &emsp;{{ driver.name }}
                          </v-list-item-subtitle>
                        </v-list-item-content>

                      </template>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div
                v-if="$vuetify.breakpoint.mdAndUp"
                style="width: 30%;display: inline-block;text-align: right;"
              >
                <v-btn
                  :disabled="isPrevious"
                  color="error-gradients"
                  class="white--text"
                  @click="allocationConfirmedButtonClickEvent"
                >
                  <v-icon small>
                    mdi-truck-outline
                  </v-icon>
                  &nbsp;配車確定
                </v-btn>
              </div>
            </div>
            <div
              v-if="$vuetify.breakpoint.smAndDown"
              class="mt-2"
            >
              <v-btn
                block
                :disabled="isPrevious"
                color="error-gradients"
                class="white--text"
                @click="allocationConfirmedButtonClickEvent"
              >
                <v-icon small>
                  mdi-truck-outline
                </v-icon>
                &nbsp;配車確定
              </v-btn>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="4"
            style="text-align: right;"
          >
            <allocation-switch-button
              :current-view="currentView"
              @switchView="switchView"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="lastUpdatedAt"
          dense
        >
          <v-col cols="12">
            <span><small>最終保存日時</small>&nbsp;</span>
            <span><small>{{ lastUpdatedAt | unix_datetime_format }}</small></span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            style="height: 70vh; overflow-y: auto;max-width: 97.5%"
          >
            <div
              v-if="drivers.length > 0"
            >
              <template
                v-for="driver in drivers"
              >
                <v-row :key="driver.id" dense>
                  <v-col v-if="driver.enabled">
                    <v-card
                      class="rounded-card"
                      flat
                      style="background-color: #E9EFF0"
                    >
                      <v-card-text>
                        <v-row>
                          <!-- ユーザー項目 -->
                          <v-col
                            align="center"
                            col="12"
                            md="2"
                            xl="2"
                            style="padding-bottom: 2px;"
                          >
                            <div class="leftBox">
                              <!-- メニュー -->
                              <div
                                class="child"
                                style="width: 5%;margin-top: 10px;"
                              >
                                <div>
                                  <v-btn
                                    :disabled="isPrevious"
                                    icon
                                    @click="instructionDialogButtonClickEvent(driver.id, null)"
                                  >
                                    <v-icon>mdi-pencil</v-icon>
                                  </v-btn>
                                  <v-menu
                                    :disabled="isPrevious"
                                    bottom
                                    right
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        :disabled="isPrevious"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list
                                      dense
                                    >
                                      <v-list-item
                                        link
                                        @click="callSelectDriverDialogButtonClickEvent(driver)"
                                      >
                                        <v-list-item-title>
                                          ドライバーを入れ替える
                                        </v-list-item-title>
                                      </v-list-item>
                                      <v-divider />
                                      <v-list-item
                                        :disabled="driver.schedules.length <= 0"
                                        link
                                        @click="clearTaskButtonClickEvent(driver)"
                                      >
                                        <v-list-item-title
                                          class="error--text font-weight-bold"
                                        >
                                          配車をすべて解除
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </div>
                              </div>
                              <!-- /メニュー -->
                              <!-- ユーザー情報 -->
                              <div class="child" style="width: 80%;margin-top: 10px;">
                                <draggable
                                  :group="{ name: 'drivers', pull: true, put: pullCheck }"
                                  :list="[driver]"
                                  class="dragArea"
                                  typeable="driver"
                                  ghost-class="ghost"
                                  :move="onMoveEventCallback"
                                  @end="onEndEvent"
                                >
                                  <div>
                                    <v-badge
                                      color="info"
                                      :content="driver.collection_place_count"
                                      :value="driver.collection_place_count"
                                      overlap
                                    >
                                      <v-avatar
                                        color="primary"
                                        size="45"
                                      >
                                        <v-img
                                          v-if="driver.image_url"
                                          :alt="`${driver.name} avatar`"
                                          :src="driver.image_url"
                                        />
                                        <span v-else class="primary white--text">
                                          {{ driver.name.slice(0, 2) }}
                                        </span>
                                      </v-avatar>
                                    </v-badge>
                                    <p class="mb-0">
                                      <small>{{ driver.name }}</small>
                                    </p>
                                  </div>
                                </draggable>
                              </div>

                              <!-- /ユーザー情報 -->
                              <!-- 操作ボタン -->
                              <div class="child" style="width: 15%;text-align: right;margin-top: 13px;">
                                <v-btn
                                  :disabled="isPrevious"
                                  color="primary"
                                  fab
                                  small
                                  elevation="1"
                                  @click="callAssignDialogButtonClickEvent(driver.id)"
                                >
                                  <v-icon dark>
                                    mdi-plus
                                  </v-icon>
                                </v-btn>
                              </div>
                              <!-- /操作ボタン -->
                            </div>
                          </v-col>
                          <!-- /ユーザー項目 -->
                          <!-- タスク -->
                          <v-col cols="12" md="10" xl="10" class="pb-1 pt-1" style="position: relative;">
                            <horizontal-scroll class="horizontal-scroll" style="height: 96px">
                              <user-task
                                :target-driver="driver"
                                :target-date="targetDate"
                                :typeable="`first`"
                                :is-previous="isPrevious"
                                @callVehicleDialog="openVehicleDialog"
                                @callInstructionEditDialog="instructionDialogButtonClickEvent"
                                @removeInstructionCallBack="instructionRemoveMenuClickEvent"
                                @openDriverInstructionDialog="openDriverInstructionDialog"
                                @releaseDispatchCallback="releaseDispatchCallback"
                                @cancelOrderCallback="cancelOrderCallback"
                                @reloadDriverSchedule="searchDriverSchedules"
                                @reloadAllocations="searchAllocations"
                              />
                              <v-sheet
                                v-if="driver.schedules.length <= 0"
                                class="dragGuidance"
                                style="position: absolute;top: 0;width: 91%"
                              >
                                <div
                                  v-show="$vuetify.breakpoint.mdAndUp"
                                  class="text-h6"
                                >
                                  <v-icon>mdi-plus</v-icon>&nbsp;右側の受注をドラッグ＆ドロップしてください
                                </div>
                              </v-sheet>
                            </horizontal-scroll>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </div>
            <div
              v-else
              class="text-center"
            >
              <h3 class="text--accent-1">
                ドライバーが登録されていません。
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <!-- /配車管理一覧 -->
    </v-row>

    <div
      v-if="$vuetify.breakpoint.mdAndUp"
      class="collectResult"
      :class="enableResult ? '' : 'closed'"
    >
      <div class="buttonBlock">
        <v-btn
          rounded
          icon
          @click="enableResult = !enableResult"
        >
          <v-icon
            v-if="enableResult"
            color="primary"
            x-large
          >
            mdi-arrow-right
          </v-icon>
          <v-icon
            v-if="!enableResult"
            color="primary"
            x-large
          >
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </div>

      <div class="resultBlock">
        <v-row>
          <v-col>
            <v-card
              outlined
              class="rounded-card"
            >
              <v-card-title>受注一覧</v-card-title>
              <v-card-subtitle>
                <v-tabs
                  v-model="selectedTab"
                  grow
                >
                  <v-tab
                    href="#undistributed"
                  >
                    本日の受注 ({{ unassignedOrderTotalCount }})件
                  </v-tab>
                  <v-tab
                    href="#unspecified"
                  >
                    日付未定の受注 ({{ unassignedUrgentAnytimeCount }})件
                  </v-tab>
                </v-tabs>
              </v-card-subtitle>
              <v-card-text style="height: 55vh;overflow-y: scroll">
                <v-tabs-items v-model="selectedTab">
                  <v-tab-item value="undistributed">
                    <v-row
                      v-if="unassignedOrders"
                    >
                      <v-col
                        v-for="order in unassignedOrders"
                        :key="order.id"
                        cols="12"
                        md="6"
                      >
                        <draggable
                          :list="[order]"
                          :name="`main_task_${order.id}`"
                          :group="{ name: 'undistributed', pull: true, put: false }"
                          class="list-group order-list"
                          ghost-class="ghost"
                        >
                          <div class="card">
                            <strong
                              v-if="order.preferred_start_time || order.preferred_end_time"
                              class="red--text"
                            >
                              {{ order.preferred_start_time }}-{{ order.preferred_end_time }}
                            </strong>
                            <strong
                              v-else
                            >
                              &nbsp;
                            </strong>
                            <h5
                              class="pl-1"
                              :title="`受注番号: ${ order.order_no }\n${ order.supplier_name || '' }\n${ order.supplier_location_name || '' }: ${ order.supplier_location_address }`"
                            >
                              {{ order.supplier_name }}
                            </h5>
                            <div>
                              <h6
                                class="pl-1"
                              >
                                {{ order.supplier_location_name }}
                              </h6>
                            </div>
                            <div class="subtitle-2">
                              <v-chip
                                v-if="order.item_name"
                                :title="`${ order.all_item_name || '' }`"
                                style="background-color: #F0E6D0;"
                                label
                                x-small
                              >
                                {{ order.item_name | truncate(10) }}
                              </v-chip>
                              <small><span v-if="order.total_items_count > 1">&emsp;全&nbsp;{{ order.total_items_count }}件</span></small>
                              <span v-if="!order.item_name">&emsp;</span>
                            </div>
                          </div>
                        </draggable>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item value="unspecified">
                    <v-row v-if="unassignedUrgentOrders.length > 0">
                      <v-col cols="12">
                        <p class="red--text mb-0">
                          ●&nbsp;急ぎ
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <v-row>
                          <v-col
                            v-for="order in unassignedUrgentOrders"
                            :key="order.id"
                            cols="12"
                            md="6"
                          >
                            <draggable
                              :list="[order]"
                              :group="{ name: 'undistributed', pull: true, put: false }"
                              name="urgent_task"
                              class="list-group order-list"
                              ghost-class="ghost"
                            >
                              <div class="card">
                                <strong
                                  v-if="order.preferred_start_time || order.preferred_end_time"
                                  class="red--text"
                                >
                                  {{ order.preferred_start_time }}-{{ order.preferred_end_time }}
                                </strong>
                                <strong v-else>
                                  &nbsp;
                                </strong>
                                <v-icon
                                  v-if="order.urgent"
                                  color="red"
                                  x-small
                                >
                                  mdi-circle
                                </v-icon>
                                <h5
                                  class="pl-1"
                                  :title="`受注番号: ${ order.order_no }\n${ order.supplier_name || '' }\n${ order.supplier_location_name || '' }: ${ order.supplier_location_address }`"
                                >
                                  {{ order.supplier_name }}
                                </h5>
                                <div>
                                  <h6
                                    class="pl-1"
                                  >
                                    {{ order.supplier_location_name }}
                                  </h6>
                                </div>
                                <div class="subtitle-2">
                                  <v-chip
                                    v-if="order.item_name"
                                    :title="`${ order.all_item_name || '' }`"
                                    style="background-color: #F0E6D0;"
                                    label
                                    x-small
                                  >
                                    {{ order.item_name | truncate(10) }}
                                  </v-chip>
                                  <small><span v-if="order.total_items_count > 1">&emsp;全&nbsp;{{ order.total_items_count }}件</span></small>
                                  <span v-if="!order.item_name">&emsp;</span>
                                </div>
                              </div>
                            </draggable>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="unassignedAnytimeOrders.length > 0">
                      <v-col cols="12">
                        <p class="info--text mb-0">
                          ●&nbsp;指定なし
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <v-row>
                          <v-col
                            v-for="order in unassignedAnytimeOrders"
                            :key="order.id"
                            cols="12"
                            md="6"
                          >
                            <draggable
                              :list="[order]"
                              :group="{ name: 'undistributed', pull: true, put: false }"
                              class="list-group order-list"
                              ghost-class="ghost"
                              name="unspecified_task"
                            >
                              <div class="card">
                                <strong
                                  v-if="order.preferred_start_time || order.preferred_end_time"
                                  class="red--text"
                                >
                                  {{ order.preferred_start_time }}-{{ order.preferred_end_time }}
                                </strong>
                                <strong v-else>
                                  &nbsp;
                                </strong>
                                <h5
                                  class="pl-1"
                                  :title="`受注番号: ${ order.order_no }\n${ order.supplier_name || '' }\n${ order.supplier_location_name || '' }: ${ order.supplier_location_address }`"
                                >
                                  {{ order.supplier_name }}
                                </h5>
                                <div>
                                  <h6
                                    class="pl-1"
                                  >
                                    {{ order.supplier_location_name }}
                                  </h6>
                                </div>
                                <div class="subtitle-2">
                                  <v-chip
                                    v-if="order.item_name"
                                    :title="`${ order.all_item_name || '' }`"
                                    style="background-color: #F0E6D0;"
                                    label
                                    x-small
                                  >
                                    {{ order.item_name | truncate(10) }}
                                  </v-chip>
                                  <small><span v-if="order.total_items_count > 1">&emsp;全&nbsp;{{ order.total_items_count }}件</span></small>
                                  <span v-if="!order.item_name">&emsp;</span>
                                </div>
                              </div>
                            </draggable>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <unregistered-order-dialog
      :enable-dialog="enableUnassignedDialog"
      :target-date="targetDate"
      :target-driver-id="targetDriverId"
      @closeEvent="closeDialogAndClearVariables"
      @registerEvent="unregisteredOrderDialogRegisterCallback"
    />

    <vehicle-dialog
      :enable-dialog="enableVehicleDialog"
      :target-driver-id="targetDriverId"
      :target-schedule-detail-id="targetScheduleDetailId"
      :target-date="targetDate"
      @closeEvent="closeDialogAndClearVariables"
      @registerEvent="vehicleDialogCallback"
    />
    <replacement-driver-dialog
      :enable-dialog="enableReplacementDriverDialog"
      :target-driver-id="targetDriverId"
      @closeEvent="closeDialogAndClearVariables"
      @registerEvent="selectDriverCallback"
    />
    <instruction-dialog
      :enable-dialog="enableInstructionDialog"
      :target-date="targetDate"
      :target-driver-id="targetDriverId"
      :target-schedule-detail-id="targetScheduleDetailId"
      @closeEvent="closeDialogAndClearVariables"
      @registerCallback="instructionCallback"
    />
    <!-- オーダー ドライバー指示メモ -->
    <order-instruction-dialog
      :enable-dialog="enableOrderInstructionDialog"
      :target-driver-id="targetDriverId"
      :target-order-id="targetOrderId"
      @closeEvent="closeDialogAndClearVariables"
      @registerEvent="driverInstructionDialogCallback"
    />
    <!-- /オーダー ドライバー指示メモ -->

    <confirm ref="confirm" />

    <v-dialog
      v-model="showCannotClearDriverTasksDialog"
      width="500"
      @click:outside="cannotClearDriverTaskCloseButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          color="red"
          dark
          dense
          flat
        >
          <v-toolbar-title class="white--text">
            警告
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4 text-center">
          解除が行えない受注が含まれているため一括解除できません。<br />
          解除する場合は、個別に解除を行ってください。
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cannotClearDriverTaskCloseButtonClickEvent"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'
import Confirm from '../../../../components/Confirm'
import HorizontalScroll from 'vue-horizontal-scroll'
import UserTask from '../components/_UserTask'
import ReplacementDriverDialog from '../dialogs/_ReplacementDriverDialog'
import UnregisteredOrderDialog from '../dialogs/_UnregisteredOrderDialog'
import InstructionDialog from '../dialogs/_Instruction'
import OrderInstructionDialog from '../dialogs/_OrderInstructionDialog'
import VehicleDialog from '../dialogs/_VehicleDialog'

// 画面上部の画面切り替えボタンを表す
import AllocationSwitchButton from '../components/_SwitchButton'
import {mapActions} from "vuex";

export default {
  name: 'AllocationEntryView',
  components: {
    UserTask,
    Confirm,
    draggable,
    ReplacementDriverDialog,
    UnregisteredOrderDialog,
    InstructionDialog,
    OrderInstructionDialog,
    VehicleDialog,
    HorizontalScroll,
    AllocationSwitchButton,
  },
  props: {
    currentView: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      enableUnassignedDialog: false,
      enableVehicleDialog: false,
      enableInstructionDialog: false,
      enableOrderInstructionDialog: false,
      enableReplacementDriverDialog: false,

      showCannotClearDriverTasksDialog: false,

      /** ドライバーアバターの移動 */
      draggableDriver: null,
      droppableDriver: null,

      enableResult: false,
      menuButtonSelected: null,
      showDriverSetting: false,
      showAssignDialog: false,
      targetDate: null,
      targetOrderId: null,
      targetDriverId: null,
      targetScheduleDetailId: null,

      sortPriority: 'driver_sorts',
      selectedTab:'undistributed',
      lastUpdatedAt: null,
      /** 受注件数 */
      unassignedOrderCount: 0,
      /** 日付未定の受注数 */
      unassignedUrgentAnytimeCount: 0,
      /** ドライバー */
      drivers: [],
      /** 受注一覧 */
      unassignedOrders: [],
      /** 受注(至急)一覧 */
      unassignedUrgentOrders: [],
      /** 受注(いつでも)一覧 */
      unassignedAnytimeOrders: [],
      sortPriorities: [
        {
          value: 'driver_sorts',
          text: 'ドライバー表示順'
        },
        {
          value: 'many_tasks',
          text: '配車量の多い順'
        },
        {
          value: 'few_tasks',
          text: '配車量の少ない順'
        },
      ],
    }
  },
  computed: {
    /**
     * 画面表示日が過去日かどうかを返す
     * @return {boolean}
     */
    isPrevious () {
      return (this.targetDate < this.$dayjs().format("YYYY-MM-DD"))
    },
    unassignedOrderTotalCount () {
      let counter = 0
      if (this.unassignedOrders.length <= 0) {
        return counter
      }
      for (const nonAllocate of this.unassignedOrders) {
        counter = counter + 1
      }
      return counter
    },
  },
  watch: {
    /**
     * 対象日を監視.
     * 対象日に変更があった場合は画面情報取り直し
     */
    targetDate () {
      // this.isPrevious = (newValue < moment().format("YYYY-MM-DD"))
      this.reloadAll()
    },
    menuButtonSelected (newVal) {
      this.$emit('switchView', newVal)
    },
    unassignedUrgentOrders () {
      this.unassignedUrgentAnytimeCount = 0
      this.unassignedUrgentAnytimeCount = this.unassignedUrgentOrders.length + this.unassignedAnytimeOrders.length
    },
    unassignedAnytimeOrders () {
      this.unassignedUrgentAnytimeCount = 0
      this.unassignedUrgentAnytimeCount = this.unassignedUrgentOrders.length + this.unassignedAnytimeOrders.length
    },
  },
  created() {
    this.menuButtonSelected = this.currentView
    this.targetDate = this.$dayjs().format("YYYY-MM-DD")
  },
  methods: {
    /* ドライバー */
    ...mapActions('DriverAllocationDriver', {
      fetchDrivers: 'index',
    }),
    /* 最終更新日時 */
    ...mapActions('DriverAllocationLastUpdate', {
      fetchLastUpdate: 'show'
    }),
    /* ドライバーごとのスケジュール */
    ...mapActions('DriverAllocationDriverSchedule', {
      fetchDriverSchedules: 'index',
      rearrangeDriverSchedule: 'create',
      cancelDriverSchedule: 'cancel'
    }),
    /* 受注一覧 */
    ...mapActions('DriverAllocationUnassignedOrder', {
      fetchUnassignedOrders: 'index',
    }),
    /* 受注(至急)一覧 */
    ...mapActions('DriverAllocationUnassignedUrgentOrder', {
      fetchUnassignedUrgentOrders: 'index',
    }),
    /* 受注(いつでも)一覧 */
    ...mapActions('DriverAllocationUnassignedAnytimeOrder', {
      fetchUnassignedAnytimeOrders: 'index',
    }),
    ...mapActions('DriverAllocationDriverInstruction', {
      deleteInstruction: 'destroy',
    }),
    ...mapActions('DriverAllocateEntryDriverAssign', {
      createDriverAssign: 'create',
    }),
    ...mapActions('DriverAllocationDriverSwitching', {
      switchingDriver: 'update'
    }),

    ...mapActions('DriverAllocationDriverRelease', {
      deleteScheduleDetails: 'destroy',
    }),
    ...mapActions('DriverAllocationAllocate', {
      dispatchAllocations: 'update',
    }),
    switchView (viewType) {
      this.menuButtonSelected = viewType
    },
    /**
     * ヘッダー 日付 戻るボタン クリックイベント
     */
    previousButtonClickEvent () {
      this.targetDate = this.$dayjs(this.targetDate).add(-1, 'days').format('YYYY-MM-DD')
    },
    /**
     * ヘッダー日付 進むボタン クリックイベント
     */
    nextButtonClickEvent () {
      this.targetDate = this.$dayjs(this.targetDate).add(1, 'days').format('YYYY-MM-DD')
    },
    /**
     * 配車確定ボタン クリックイベント
     */
    allocationConfirmedButtonClickEvent () {
      let modalOption = { title: '確定送信', message: '配車を確定します。よろしいですか？', options: { titleColor: 'red', cancelTitle: 'いいえ', successTitle: 'はい' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          let params = { target_date: this.targetDate }
          this.dispatchAllocations({params: params}).then(()=> {
            this.reloadAll()
          })
        }
      })
    },
    /**
     * ダイアログを閉じる共通処理
     */
    closeDialogAndClearVariables () {
      this.targetOrderId = null
      this.targetDriverId = null
      this.targetScheduleDetailId = null
      this.enableUnassignedDialog = false
      this.enableInstructionDialog = false
      this.enableOrderInstructionDialog = false
      this.enableVehicleDialog = false
      this.enableReplacementDriverDialog = false
    },
    /**
     * その他配車指示メモメニュー クリックイベント
     * @param driver_id {Number}
     * @param schedule {Object}
     */
    instructionDialogButtonClickEvent(driver_id, schedule) {
      this.targetDriverId = driver_id
      this.targetScheduleDetailId = null
      if (schedule) {
        this.targetScheduleDetailId = schedule.id
      }
      this.enableInstructionDialog = true
    },
    /**
     * その他配車指示登録 コールバック
     * @param driver_id {Number}
     * @param schedule {Object}
     */
    instructionCallback (driver_id, schedule) {
      let driver = this.drivers.find(v => v.id === driver_id)
      if (driver) {
        let target_schedule = driver.schedules.find(v => v.id === schedule.id)
        if (target_schedule) {
          target_schedule.title = schedule.title
          target_schedule.content = schedule.content
        } else {
          driver.schedules.push(schedule)
        }
      }
      this.searchLastUpdate()
      this.closeDialogAndClearVariables()
    },
    /**
     * その他指示メモ削除メニュー コールバック
     * @param driver_id
     * @param schedule_id
     */
    instructionRemoveMenuClickEvent (driver_id, schedule_id) {
      let modalOption = { title: '削除', message: '削除します。よろしいですか？', options: { titleColor: 'red', cancelTitle: 'いいえ', successTitle: 'はい' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteInstruction({ driver_id: driver_id, id: schedule_id }).then(() => {
            this.searchDriverSchedules(driver_id)
          })
        }
      })
    },
    /**
     * ドライバーを入れ替える メニュー クリックイベント
     * @param driver { Object }
     * @description ドライバー入れ替えダイアログを表示する.
     */
    callSelectDriverDialogButtonClickEvent (driver) {
      this.targetDriverId = driver.id
      this.enableReplacementDriverDialog = true
    },
    /**
     * 配車をすべて解除 クリックイベント
     * @param driver
     */
    clearTaskButtonClickEvent(driver) {
      //　解除できない条件を抽出
      let result = driver.schedules.find((schedule) => { return (schedule.schedule_type === 'collection' && schedule.confirmed) })
      if (result) {
        this.showCannotClearDriverTasksDialog = true
      } else {
        let modalOption = { title: '配車を解除', message: 'すべての配車を解除します。よろしいですか？', options: { titleColor: 'red', width: 350, cancelTitle: 'いいえ', successTitle: 'はい' } }
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            this.deleteScheduleDetails({ driver_id: driver.id, target_date: this.targetDate }).then(() => {
              this.reloadAll()
            })
          }
        })
      }
    },

    cannotClearDriverTaskCloseButtonClickEvent () {
      this.showCannotClearDriverTasksDialog = false
    },
    /**
     * ドライバー指示メモダイアログ 表示
     * @param driver_id { Number }
     * @param task { Object }
     */
    openDriverInstructionDialog (driver_id, task) {
      this.targetDriverId = driver_id
      this.targetOrderId = task.order_id
      this.enableOrderInstructionDialog = true
    },
    /**
     * ドライバー指示メモダイアログ コールバック処理
     */
    driverInstructionDialogCallback () {
      this.closeDialogAndClearVariables()
    },
    /**
     * 車両を指定するダイアログ 表示
     * @param driver_id { Number }
     * @param task { Object }
     */
    openVehicleDialog(driver_id, task) {
      this.targetDriverId = driver_id
      this.targetScheduleDetailId = task.original_id
      this.enableVehicleDialog = true
    },
    /**
     * 車両を指定モーダル 登録後コールバック処理
     * @param driver_id { Number }
     * @param schedule_detail_id { Number }
     * @param forms {Object}
     */
    vehicleDialogCallback (driver_id, schedule_detail_id, forms) {
      let driver = this.drivers.find(v => v.id === driver_id)
      if (driver) {
        let order = driver.schedules.find(v => v.original_id === schedule_detail_id && v.schedule_type === 'collection')
        if (order) {
          order.vehicle_id = forms.vehicle_id
          order.vehicle_name = forms.vehicle_name
          order.vehicle_number = forms.vehicle_number
        }
      }
      this.closeDialogAndClearVariables()
    },
    /**
     * 配車の解除を行います.
     * タスクの洗い替えを実施
     * @param driver_id
     * @param order_id
     */
    releaseDispatchCallback (driver_id, order_id) {
      this.cancelDriverSchedule({driver_id: driver_id, id: order_id, target_date: this.targetDate}).then(() => {
        this.reloadAll()
      })
    },
    /**
     * オーダーキャンセルボタン コールバック処理
     * オーダーキャンセル
     * @param driver_id { Number } ドライバーID
     * @param order_id { Number } オーダーID
     */
    cancelOrderCallback (driver_id, order_id) {
      this.cancelDriverSchedule({driver_id: driver_id, id: order_id, target_date: this.targetDate}).then(() => {
        this.reloadAll()
      })
    },
    /**
     * ドライバーを入れ替える ダイアログ コールバック処理
     * @param source_id { Number } 入れ替え元
     * @param destination_id {Number} 入れ替え先
     */
    selectDriverCallback (source_id, destination_id) {
      let params = { target_date: this.targetDate, target_id: destination_id }
      this.switchingDriver({ base_driver_id: source_id, params: params }).then(() => {
        this.reloadAll()
        this.closeDialogAndClearVariables()
      })
    },

    callAssignDialogButtonClickEvent (driver_id) {
      this.targetDriverId = driver_id
      this.enableUnassignedDialog = true
    },
    /**
     * メモ削除のコールバック処理
     * @param driver_id { Number }
     * @param schedule_detail_id { Number }
     */
    removeMemoCallBack (driver_id, schedule_detail_id) {
      this.deleteInstruction({ driver_id: driver_id, id: schedule_detail_id }).then(() => {
        this.searchDriverSchedules(driver_id)
      })
    },
    /**
     * 受注一覧モーダル コールバック
     * 受注一覧モーダルで作成した受注情報をドライバーのタスクにマージ
     * その後、受注一覧モーダル・右メニューより選択した要素を削除する。
     */
    unregisteredOrderDialogRegisterCallback () {
      this.reloadAll()
      this.closeDialogAndClearVariables()
    },
    pullCheck (to, from) {
      let fromName = from.options
      return (fromName.typeable === 'driver')
    },
    /**
     * 顔移動
     * @param dataTransfer
     * @param dragEl
     * @return {boolean}
     */
    onEndEvent (dataTransfer, dragEl) {
      if (this.draggableDriver && this.droppableDriver) {
        this.selectDriverCallback (this.draggableDriver.id, this.droppableDriver.id)
      }
      this.draggableDriver = null
      this.droppableDriver = null
      return false
    },
    onMoveEventCallback (evt) {
      if (this.isPrevious) {
        return false
      }
      this.draggableDriver = evt.draggedContext.element
      this.droppableDriver = evt.relatedContext.element
      return true
    },
    /**
     * カレンダー日付変更　コールバック
     */
    targetDateChangedCallback (value) {
      this.targetDate = value;
    },
    /**
     * ソートドロップダウン チェンジイベント
     */
    sortChangeEvent () {
      this.searchDrivers()
    },
    /**
     * ドライバーを展開
     */
    searchDrivers () {
      this.fetchDrivers({ target_date: this.targetDate, sort: this.sortPriority }).then((content) => {
        this.drivers = content.drivers
      })
    },
    /**
     * ドライバーに関連付くスケジュールを取得する.
     * @param driver_id
     */
    searchDriverSchedules (driver_id) {
      /**
       * @typedef content { Object }
       * @property schedules { Array }
       */
      this.fetchDriverSchedules({ driver_id: driver_id, target_date: this.targetDate }).then((content) => {
        let driver = this.drivers.find(v => v.id === driver_id)
        driver.schedules = content.schedules
      })
      this.searchLastUpdate()
    },
    /**
     * 画面上の全データをリロード
     */
    reloadAll() {
      // ドライバー情報をリロード
      this.searchDrivers()
      // 受注情報をリロード
      this.searchAllocations()
    },
    /**
     * 受注一覧を全て取得
     */
    searchAllocations () {
      this.searchUnassignedUrgentOrders()
      this.searchUnassignedAnytimeOrders()
      this.searchUnassignedOrders()
      this.searchLastUpdate()
    },

    /**
     * 受注一覧の展開
     */
    searchUnassignedOrders () {
      this.unassignedOrders = []
      /**
       * @typedef content { Object }
       * @property non_allocations { Array }
       */
      this.fetchUnassignedOrders({ target_date: this.targetDate }).then((content) => {
        this.unassignedOrders = content.orders
      })
    },
    /**
     * 受注(至急)一覧の展開
     */
    searchUnassignedUrgentOrders () {
      this.unassignedUrgentOrders = []
      this.fetchUnassignedUrgentOrders().then((content) => {
        this.unassignedUrgentOrders = content.orders
      })
    },
    /**
     * 受注(いつでも)一覧の展開
     */
    searchUnassignedAnytimeOrders () {
      this.unassignedAnytimeOrders = []
      this.fetchUnassignedAnytimeOrders().then((content) => {
        this.unassignedAnytimeOrders = content.orders
      })
    },
    /**
     * 最終更新日時の取得
     */
    searchLastUpdate () {
      this.fetchLastUpdate({target_date: this.targetDate}).then((content) => {
        this.lastUpdatedAt = content.last_updated_at
      })
    },

  }
}
</script>

<style scoped lang="scss">

div.collectResult {
  position: absolute;
  height: 72vh;
  width: 400px;
  top: 10%;
  right: 20px;
  transition: width 0.5s, height 2s, background-color 2s, transform 0.5s;

  &.closed {
    width: 20px;
  }

  & .buttonBlock {
    position: absolute;
    z-index: 5;
    top: 40%;
    left: -42px;
    height: 55px;
    width: 43px;
    background-color: white;
    padding-top: 9px;
    padding-left: 6px;
    border: solid 1px #ddd;
    border-right: none;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  & .resultBlock {
    position: relative;
    width: 400px;
    height: 100%;
    margin: 0 auto;
  }
}

button.ex-small {
  height: 28px !important;
  width: 28px !important;
  & i {
    font-size: 18px !important;
  }
}
.leftBox {
  display: flex;
  height: 100%;
  & div.child {
  }
}
.ghost {
  opacity: 0.4;
}
div.chip {
  padding-top: 2px;
  padding-left: 5px;
  & p {
    margin: 0;
  }
}
div.add {
  height: 100%;
  width: 50px;
  border: 1px dotted #565656;
  position: relative;
  background-color: #ddd;
  z-index: 1;
  & .button {
    display: inline-block;
    width: 100%;
    height: 100%;
    & i {
      width: 100%;
      height: 100%;
      text-align: center;
      vertical-align: middle;
      position: absolute;
      top: 30%;
    }
  }
}
div.card {
  position: relative;
  width: 95%;
  padding: 5px;
  box-shadow: 10px 5px 0 0 rgb(241, 240, 240);
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1;
  border-radius: 10px;
}

.card-layout {
  width: 190px;
  float: left;
  margin-right: 5px;
  height: 60px;
  &::after {
    background-color: rgb(233, 239, 240) !important;
    content: ' '
  }
}

.memoCard {
  background-color: #FDEFC1 !important;
}
.destinationCard {
  width: 150px !important;
}

.dragGuidance {
  display: table;
  width: 100%;
  height: 100%;
  background-color: rgb(233, 239, 240) !important;
  border: dotted 2px #B7C8CC !important;
  text-align: center;
  border-radius: 15px;

  & div {
    display: table-cell;
    vertical-align: middle;
    color: #B7C8CC;
  }
}

.order-list {
  & h5 {
    white-space:nowrap;
    width: 85%;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  & h6 {
    white-space:nowrap;
    width: 85%;
    overflow:hidden;
    text-overflow:ellipsis;
  }
}

</style>
